import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationComponent, DismissReason, ModalOptions } from "@shared/components/confirmation/confirmation.component";
import { Observable } from "rxjs";

export interface DeactivateModalOptions extends ModalOptions {
  deactivateOnCancel?: boolean;
}

export class DeactivateUtil {
  public static confirmDeactivate(
    modalService: NgbModal,
    modalOptions: DeactivateModalOptions): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      ConfirmationComponent.createModal(modalService, {
        modalSize: 'lg',
        ...modalOptions,
        confirmFn: () => observer.next(!modalOptions?.deactivateOnCancel),
        cancelFn: (reason) => {
          const deactivate = reason === DismissReason.CANCELLED && !!modalOptions?.deactivateOnCancel
          observer.next(deactivate);
        }
      });
    });
  }
}
